import { createSlice } from "@reduxjs/toolkit";

const initialState = { value: "" };

export const extraLessonSlice = createSlice({
  name: "lesson",
  initialState,
  reducers: {
    extraLessonReducer: (state, action) => {
      state.value = action.payload;
    },
  },
});
export const { extraLessonReducer } = extraLessonSlice.actions;
export default extraLessonSlice.reducer;
